var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import T from '../../Utils/Locale';
import PurchaseButton from './PurchaseButton';
import PurchaseType, { getPurchaseTypesAsSelectOptions } from '../Purchase/PurchaseType';
import { showPurchaseButton } from './PriceBoxTypeContent';
import getProductPrice from '../../Utils/GetProductPrice';
import useEndpoint from '../../Hooks/UseEndpoint';
import { Select, Option } from '@frontend-components/components/Select';
import { formatPrice } from '@frontend-components/utils/formatPrice';
const AboutPriceSelection = ({ productType, selectedType, setSelectedType, document = null }) => {
    const [options, setOptions] = useState(getPurchaseTypesAsSelectOptions());
    const showText = () => document && document.purchasedAsType === PurchaseType.ADVICE;
    // When component is mounted, try to fetch the options with a price.
    useEndpoint(`/api/bookings?product=${productType}&status=created,rebooked&is_paid=0`, (bookings) => __awaiter(void 0, void 0, void 0, function* () {
        const prices = yield getProductPrice(productType);
        let optionsWithPrice = Object.assign({}, options);
        // If any unpaid bookings exists, set the only purchase type as the booking type.
        if (bookings.length > 0) {
            bookings.shift().items.forEach(item => {
                if (item.document.type === productType) {
                    optionsWithPrice = { [item.purchase_type]: optionsWithPrice[item.purchase_type] };
                }
            });
        }
        const isUpgrade = document != null && document.purchasedAsType && document.purchasedAsType !== PurchaseType.ADVICE;
        Object.keys(optionsWithPrice).forEach((purchaseType) => {
            if (isUpgrade) {
                if (prices[purchaseType] - prices[document.purchasedAsType] > 0) {
                    optionsWithPrice[purchaseType] = `${T(`purchase_type.${purchaseType}`)} ${formatPrice(prices[purchaseType] - prices[document.purchasedAsType])}`;
                }
                else {
                    optionsWithPrice[purchaseType] = `${T(`purchase_type.${purchaseType}`)} ${formatPrice(0)}`;
                }
            }
            else {
                optionsWithPrice[purchaseType] = `${T(`purchase_type.${purchaseType}`)} ${formatPrice(prices[purchaseType])}`;
            }
        });
        setOptions(optionsWithPrice);
    }), `bookings_${productType}`);
    return (_jsxs(_Fragment, { children: [_jsx("h4", Object.assign({ className: 'tailwind-reset text-gray-69 text-base' }, { children: !document || !document.isPurchased ? T('dashboard.prices.package_and_price') : T('dashboard.prices.your_package') })), _jsxs("div", Object.assign({ className: 'formWrap flex flex-row items-center' }, { children: [_jsx("div", Object.assign({ className: 'inline-block relative w-2/4' }, { children: showText() ? (_jsx("p", { children: T('dashboard.purchase_types.digital_document_advice') })) : (_jsx(Select, Object.assign({ testId: 'about_purchase_type', value: selectedType, onChange: (selectedType) => setSelectedType(selectedType), isNative: true, inputSize: 'small' }, { children: Object.entries(options).map(([key, value]) => (_jsx(Option, Object.assign({ value: key, "data-gtm": `Dashboard-${key}` }, { children: value }), key))) }))) })), showPurchaseButton(document, selectedType) && (_jsx(PurchaseButton, { productType: productType, purchaseType: selectedType, legalDocument: document }))] }))] }));
};
AboutPriceSelection.propTypes = {
    productType: PropTypes.string.isRequired,
    selectedType: PropTypes.string.isRequired,
    setSelectedType: PropTypes.func.isRequired,
    document: PropTypes.shape({
        id: PropTypes.number.isRequired,
        isPurchased: PropTypes.bool.isRequired,
        purchasedAsType: PropTypes.string
    })
};
export default AboutPriceSelection;
